import Vue from 'vue'
import Router from 'vue-router'
import mainPage from '../components/main'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'mainPage',
      component: mainPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js